import React from "react";

const BenefitCard = ({ src, title, description }) => {
  return (
    <div className="benefitCard">
      <div className="benefitCardImage">
        <span>
          <img src={src} alt={title} />
        </span>
      </div>
      <div className="benefitCardTitle">{title}</div>
      <div className="benefitCardDescription">{description}</div>
    </div>
  );
};

export default BenefitCard;
